<template>
  <div
    class="faq section"
    :style="sectionStyle"
  >
    <div class="container">
      <div
        v-if="title"
        class="title text-center q-mb-md"
        :style="titleStyle"
        v-html="$options.filters.pureHtml(title)"
      />

      <FAQItem
        v-for="(item, index) in items"
        :key="index"
        v-bind="{ ...item, itemsStyle }"
      />
    </div>
  </div>
</template>

<script>
import FAQItem from './FAQItem';
import backgroundMixin from './mixins/backgroundMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'FAQSection',
  components: { FAQItem },
  mixins: [backgroundMixin, titleMixin],
  props: {
    itemsStyle: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.faq {

}
</style>
